const formatter = new Intl.NumberFormat([], { minimumFractionDigits: 0, maximumFractionDigits: 1 });

export function formatDecimal(value: number) {
  return formatter.format(value);
}
